"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./UserListItem.scss");
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _BadgeLevel = _interopRequireDefault(require("./BadgeLevel"));
var _IconButton = _interopRequireDefault(require("./IconButton"));
var _reactIcons = require("@radix-ui/react-icons");
var DropdownMenu = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
var _Avatar = _interopRequireDefault(require("./Avatar"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UserListItem = function UserListItem(_ref) {
  var name = _ref.name,
    badge = _ref.badge,
    avatar = _ref.avatar,
    role = _ref.role;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    direction: "row",
    customClass: "UserListItem",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    style: {
      gap: "var(--size-150)"
    },
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    size: "medium",
    avatar: avatar,
    altText: name,
    role: role
  }), /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    size: "medium"
  }, name)), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    gap: 100,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(DropdownMenu.Root, null, /*#__PURE__*/_react["default"].createElement(DropdownMenu.Trigger, {
    asChild: true
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    size: "small",
    variant: "ghost"
  }, /*#__PURE__*/_react["default"].createElement(_reactIcons.Pencil1Icon, null))), /*#__PURE__*/_react["default"].createElement(DropdownMenu.Portal, null, /*#__PURE__*/_react["default"].createElement(DropdownMenu.Content, {
    className: "DropdownMenuContent",
    sideOffset: 4,
    align: "start"
  }, /*#__PURE__*/_react["default"].createElement(DropdownMenu.Item, {
    disabled: true,
    className: "DropdownMenuItem"
  }, "Send private message"), /*#__PURE__*/_react["default"].createElement(DropdownMenu.Item, {
    disabled: true,
    className: "DropdownMenuItem"
  }, "Create Slack channel")))), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    customClass: "BadgeLevelContainer"
  }, /*#__PURE__*/_react["default"].createElement(_BadgeLevel["default"], {
    badge: badge
  }))));
};
var _default = exports["default"] = UserListItem;